import React from 'react';
import MobileDevPageVideoStage from '@wix/da-ads/pkg/adunits/MobileDevPageVideoStage';
import { getDeviationType } from '../../DeviationViews/_helpers';
import { useSubscriptionTier } from '../../utils/hooks/useSubscriptionTier';
import { useShowMobileAd } from '../../ArtStage/hooks/useShowMobileAd';
import LoadingIndicator from '../../LoadingIndicator';
import ArtStage from '../../ArtStage';
import ActionBar from '../../ActionBar';
import Sidebar from '../../Sidebar';
import Details from '../../DeviationViews/Details';
import SubPaywall from '../../DeviationViews/Full/_partials/SubPaywall';
import PanelPopup from '../../DeviationPage/_partials/PanelPopup';
import { DeviationTypes } from '../../types/deviation';
import { getCommentableTypeForDeviationType, isExtendedDeviationFullyLoaded } from '../redux/helpers';
import Comments from '../_partials/Comments';
import TierUpsell from '../_partials/TierUpsell';
import UserGiftSaleBanner from '../_partials/UserGiftSaleBanner';
import LiteratureTextualContent from '../../DeviationViews/TextualContent/Literature';
import MobileAdhesion from '@wix/da-ads/pkg/adunits/MobileAdhesion';
import ErrorBoundary from '../../ErrorBoundary';
import { useSelector } from 'react-redux';
import { getCurrentAdSafety } from '../../Ads/redux/selectors';
import s from './MobileDeviationPage.scss';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const MobileDeviationPage = ({ deviation  })=>{
    const isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    const deviationType = getDeviationType(deviation);
    const isJournal = deviationType === DeviationTypes.JOURNAL;
    const isLiterature = deviationType === DeviationTypes.LITERATURE;
    const isJournalOrLit = isJournal || isLiterature;
    const { typeId , deviationId  } = deviation;
    const commentableTypeId = getCommentableTypeForDeviationType(typeId);
    const { tier , isSubscribedButBlocked , needsSubscription  } = useSubscriptionTier(deviation);
    const isBlocked = needsSubscription || isSubscribedButBlocked;
    const { showVideoAd , showAdhesionAd  } = useShowMobileAd(deviation);
    const adSafety = useSelector((state)=>getCurrentAdSafety(state));
    const isNsfgFallback = useFlag('ads_dealer_nsfg');
    return /*#__PURE__*/ React.createElement(React.Fragment, null, showAdhesionAd && /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileAdhesion"
    }, /*#__PURE__*/ React.createElement(MobileAdhesion, {
        safety: adSafety
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(ArtStage, {
        deviation: deviation
    }), showVideoAd && (adSafety !== 'off' || isNsfgFallback) && /*#__PURE__*/ React.createElement("div", {
        className: s['ad-wrapper']
    }, /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MobileDevPageVideoStage"
    }, /*#__PURE__*/ React.createElement(MobileDevPageVideoStage, {
        safety: adSafety
    }))), /*#__PURE__*/ React.createElement(ActionBar, {
        deviation: deviation
    }), isLiterature && /*#__PURE__*/ React.createElement("div", {
        className: s['lit-content']
    }, /*#__PURE__*/ React.createElement(LiteratureTextualContent, {
        deviation: deviation
    })), /*#__PURE__*/ React.createElement(PanelPopup, {
        deviation: deviation,
        actionBarType: "primary",
        className: s['large-popover-uplifted']
    }), /*#__PURE__*/ React.createElement(Details, {
        contentClassName: s['details'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement(UserGiftSaleBanner, {
        user: deviation.author
    }), isJournalOrLit && isBlocked && /*#__PURE__*/ React.createElement(SubPaywall, {
        deviation: deviation,
        showImage: false
    }), isExtendedLoaded ? /*#__PURE__*/ React.createElement(React.Fragment, null, !isBlocked && /*#__PURE__*/ React.createElement(Comments, {
        key: `${commentableTypeId}:${deviationId}`,
        deviation: deviation,
        className: s['comments']
    }), !isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    }), /*#__PURE__*/ React.createElement("div", {
        className: s['sidebar']
    }, /*#__PURE__*/ React.createElement(Sidebar, {
        deviation: deviation
    }))) : /*#__PURE__*/ React.createElement(LoadingIndicator, {
        className: s['lloader'],
        view: "llama"
    }), isBlocked && !!tier && /*#__PURE__*/ React.createElement(TierUpsell, {
        className: s['upsell'],
        deviation: deviation
    })));
};
MobileDeviationPage.displayName = 'MobileDeviationPage';
export default MobileDeviationPage;
